namespace SP.Data {
    export class Arrival {

        //private static arrivalInfo: { [arrivalId: string]: ArrivalInfo } = {};

        static async getArrivalInfo(arrivalId: string, useCache = true) {
            //if (useCache && this.arrivalInfo[arrivalId] != null) return this.arrivalInfo[arrivalId];
            var response = await SP.get<any>("/api/v1/info/arrivalInfo/" + arrivalId);
            if (response.status == 200) return response.data; // this.arrivalInfo[arrivalId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            //return this.arrivalInfo[arrivalId];
            //return response.data;
        }

        static async getArrivalInfos(): Promise<SP.ArrivalInfo[]> {
            var response = await SP.get<any>("/api/v1/info/arrivalInfos");
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

        static async findSender(customerId: string, keyword: string, top: number): Promise<string[]> {
            var response = await SP.get<any>("/api/v1/arrival/findSender?customerId=" + customerId + "&keyword=" + keyword + "&top=" + top);
            if (response.status != 200) await SP.alertX(response.status + ": " + response.msg);
            return response.data;
        }

    }
}


